import Chart from "react-apexcharts";
import React from "react";

import "./styles.css";
import moment from "moment";

export const CustomersByType = ({ data }) => {
  if (!data) return null;

  // Get the most recent data for pie chart
  const latestData = Object.values(data)[Object.values(data).length - 1];
  const companyTaxations = latestData.company_taxations;

  const pieData = [
    {
      name: "Lucro Presumido",
      value: companyTaxations.presumed_profit_count,
    },
    {
      name: "Lucro Real",
      value: companyTaxations.real_profit_count,
    },
    {
      name: "MEI",
      value: companyTaxations.mei_count,
    },
    {
      name: "Profissional Liberal",
      value: companyTaxations.liberal_professional_count,
    },
    {
      name: "Simples Nacional",
      value: companyTaxations.simple_national_count,
    },
    {
      name: "Domésticas",
      value: latestData.domestic_count,
    },
  ].filter(item => item.value > 0); // Only show categories with values

  return (
    <Chart
      options={{
        chart: {
          type: "pie",
          height: 350,
        },
        labels: pieData.map(item => item.name),
        tooltip: {
          y: {
            formatter: function (value) {
              return value + " clientes";
            }
          }
        },
        legend: {
          position: "bottom",
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.labels[opts.seriesIndex] + ": " + opts.w.globals.series[opts.seriesIndex];
          }
        },
        colors: ["#52c41a", "#722ed1", "#f5222d", "#40a9ff", "#faad14", "#13c2c2"],
      }}
      series={pieData.map(item => item.value)}
      type="pie"
      height={350}
    />
  );
};
